import { useEffect, useState, useRef } from "react";
import useExceptionHandler from "hooks/useExceptionHandler";
import { DateHelper, DEFAULT_PAGINATION_VALUES } from "utils";
import ListHeader from "components/PantallaList/Header/ListHeader";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import { TransaccionesManager as manager } from "managers";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import { ComprobanteElectronicoManager as comprobanteRecibidoManager } from "managers";
import { AprobacionComercialRecibidaManager as aprobacionComercialRecibidaManager } from "managers";
import { Reporte606Manager } from "managers";
import { Reporte607Manager } from "managers";
import { useAuthentication } from "hooks";
import { Permisos } from "utils/permisos";
import { Reporte606 } from "models/Reporte606";
import { Reporte607 } from "models/Reporte607";
import { Form } from "react-bootstrap";
import RadioGroup from "components/RadioGroup/RadioGroup";
import Select from "react-select";
import uuid from "react-uuid";
import useMessage from "hooks/useMessage";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { InputSidebarContainer } from "components";
import ReporteViewer from "components/Reportes/ReporteViewer";
import {
  PERIODO_TABLA_LIST,
  PERIODICIDAD_TABLA_ACTUAL_LIST,
  PERIODICIDAD_TABLA_PASADO_LIST,
  PERIODICIDAD_TABLA_OTRO_LIST,
  PERIODO_TABLA_ACTUAL,
  PERIODO_TABLA_PASADO,
  PERIODICIDAD_TABLA_OTRO_RANGO,
  PERIODO_TABLA_OTRO,
  TIPO_COMPROBANTE_LIST,
  REPORTE_CANTIDAD_TRANSACCIONES_POR_RANGO_FECHA,
  REPORTE_TRANSACCIONES_POR_RANGO_FECHA,
  REPORTE_TRANSACCIONES_ENVIADAS,
  TIPO_REPORTE_COMPROBANTES_RECIBIDOS,
  TIPO_REPORTE_APROBACIONES_RECIBIDAS,
  PERIODICIDAD_TABLA_ACTUAL_MES,
} from "utils";

export default function Reporte({ showLoading, hideLoading }) {
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [list, setList] = useState([]);
  const [showCanvasReporte, setShowCanvasReporte] = useState(false);

  const { mes: defaultMes606, ano: defaultAno606 } = Reporte606.getDefaultMesAno();
  const [reporteWhere, setReporteWhere] = useState({
    EstadoECFList: ["A", "C"],
    FormatoReporte: "PDF",
    TipoReporte: "T",
    RangoFecha: "S",
    Periodo: PERIODO_TABLA_ACTUAL,
    Periodicidad: PERIODICIDAD_TABLA_ACTUAL_MES,
    SeEnvio: "-1",
    SeRecibio: "-1",
    ConvertirMonedaLocal: false,
    TipoPeriodo606: Reporte606.TIPO_PERIODO_MENSUAL,
    Mes: defaultMes606,
    Ano: defaultAno606,
  });
  const [reporte, setReporte] = useState(undefined);
  const [tipoComprobantes, setTipoComprobantes] = useState([]);
  const [estadoComprobante, setEstadoComprobante] = useState([]);

  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const { handleException } = useExceptionHandler();
  const { cerrarAlertas } = useMessage();
  const { tienePermiso } = useAuthentication();
  const ref = useRef(null);

  const ESTADO_LIST = [
    { value: "A", label: "Aceptado" },
    { value: "C", label: "Aceptado Condicional" },
    { value: "R", label: "Rechazado" },
    { value: "P", label: "En Proceso" },
  ];

  const TIPO_REPORTE = [
    { value: "AR", label: "Aprobaciones Comerciales Recibidas" },
    { value: "C", label: "Cantidad de transacciones por rango de fecha" },
    { value: "CR", label: "Comprobantes Recibidos" },
    { value: "T", label: "Transacciones" },
    { value: "TC", label: "Transacciones Emitidas en Contingencia" },
    { value: "TE", label: "Transacciones Enviadas" },
    { value: "TF", label: "Transacciones por rango de fecha" },
    { value: "V", label: "Ventas por tipo de comprobante" },
    ...(tienePermiso(Permisos.Reporte606.IMPRIMIR)
      ? [{ value: Reporte606.TIPO_REPORTE, label: Reporte606.TIPO_REPORTE_LABEL }]
      : []),
    ...(tienePermiso(Permisos.Reporte607.IMPRIMIR)
      ? [{ value: Reporte607.TIPO_REPORTE, label: Reporte607.TIPO_REPORTE_LABEL }]
      : []),
  ];

  const RANGO_FECHA = [
    { value: "S", label: "Semanal" },
    { value: "M", label: "Mensual" },
  ];

  const FILTRO_ENVIO = [
    { value: "-1", label: "Todos" },
    { value: "S", label: "Sí" },
    { value: "N", label: "No" },
  ];

  const FILTRO_RECEPCION = [
    { value: "-1", label: "Todos" },
    { value: "S", label: "Sí" },
    { value: "N", label: "No" },
  ];

  const FORMATO_REPORTE = [
    { value: "PDF", label: "PDF" },
    { value: "Excel", label: "Excel" },
    { value: "CSV", label: "CSV" },
  ];
  const CONVERTIR_MONEDA_LOCAL = [
    { value: "true", label: "Si" },
    { value: "false", label: "No" },
  ];


  useEffect(() => {
    buscar();
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where]);

  const setCheckedProp = (e) => {
    const { name, checked } = e.target;
    setReporteWhere({
      ...reporteWhere,
      [name]: checked,
    });
  };
  function buscar() {
    const whereWithPaginationValues = {
      ...where,
      ...pagination,
    };

    manager
      .listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        try {
          for (let transaccion of res.Data) {
            transaccion["Fecha"] = DateHelper.formatStringDate(
              transaccion["Fecha"],
              false
            );
            transaccion["FechaCreacion"] = DateHelper.formatStringDate(
              transaccion["FechaCreacion"],
              true
            );
          }
        } catch (err) { }
        setList(res.Data);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());

    setTipoComprobantes([
      {
        value: "-1",
        label: "Todos",
      },
      ...TIPO_COMPROBANTE_LIST,
    ]);

    setEstadoComprobante([
      {
        value: "-1",
        label: "Todos",
      },
      ...ESTADO_LIST,
    ]);
  }

  const imprimirReporte = () => {
    switch (reporteWhere.TipoReporte) {
      case Reporte606.TIPO_REPORTE: {
        showLoading();
        const esMensual =
          reporteWhere.TipoPeriodo606 === Reporte606.TIPO_PERIODO_MENSUAL;
        const params = {
          Ano: reporteWhere.Ano,
          Mes: esMensual ? reporteWhere.Mes : null,
          TipoPeriodo: reporteWhere.TipoPeriodo606,
          FormatoReporte: reporteWhere.FormatoReporte,
        };

        if (reporteWhere.FormatoReporte === "PDF") {
          Reporte606Manager.imprimirPDF(params)
            .then((data) => {
              setReporte(data);
              setShowCanvasReporte(true);
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        } else {
          const ext = reporteWhere.FormatoReporte === "Excel" ? "xls" : "csv";
          const promise =
            reporteWhere.FormatoReporte === "Excel"
              ? Reporte606Manager.descargarExcel(params)
              : Reporte606Manager.descargarCSV(params);
          promise
            .then((blob) => {
              const link = document.createElement("a");
              link.target = "_blank";
              link.download = `Reporte606.${ext}`;
              link.href = URL.createObjectURL(blob);
              link.click();
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        }
        break;
      }

      case Reporte607.TIPO_REPORTE: {
        showLoading();
        const esMensual =
          reporteWhere.TipoPeriodo606 === Reporte607.TIPO_PERIODO_MENSUAL;
        const params = {
          Ano: reporteWhere.Ano,
          Mes: esMensual ? reporteWhere.Mes : null,
          TipoPeriodo: reporteWhere.TipoPeriodo606,
          FormatoReporte: reporteWhere.FormatoReporte,
        };

        if (reporteWhere.FormatoReporte === "PDF") {
          Reporte607Manager.imprimirPDF(params)
            .then((data) => {
              setReporte(data);
              setShowCanvasReporte(true);
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        } else {
          const ext = reporteWhere.FormatoReporte === "Excel" ? "xls" : "csv";
          const promise =
            reporteWhere.FormatoReporte === "Excel"
              ? Reporte607Manager.descargarExcel(params)
              : Reporte607Manager.descargarCSV(params);
          promise
            .then((blob) => {
              const link = document.createElement("a");
              link.target = "_blank";
              link.download = `Reporte607.${ext}`;
              link.href = URL.createObjectURL(blob);
              link.click();
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        }
        break;
      }

      case TIPO_REPORTE_COMPROBANTES_RECIBIDOS: {
        showLoading();

        let extension = "pdf";
        switch (reporteWhere.FormatoReporte) {
          case "Excel":
            extension = "xls";
            break;
          case "CSV":
            extension = "csv";
            break;
        }
        comprobanteRecibidoManager
          .reporte(reporteWhere)
          .then(async (res) => {
            const link = document.createElement("a");
            const result = await res.blob;
            link.target = "_blank";
            link.download = `${uuid()}.${extension}`;
            link.href = URL.createObjectURL(result);
            link.click();
          })
          .catch((err) => handleException(err))
          .finally(() => hideLoading());
        break;
      }

      case TIPO_REPORTE_APROBACIONES_RECIBIDAS: {
        showLoading();

        let extension = "pdf";
        switch (reporteWhere.FormatoReporte) {
          case "Excel":
            extension = "xls";
            break;
          case "CSV":
            extension = "csv";
            break;
        }
        aprobacionComercialRecibidaManager
          .reporte(reporteWhere)
          .then(async (res) => {
            const link = document.createElement("a");
            const result = await res.blob;
            link.target = "_blank";
            link.download = `${uuid()}.${extension}`;
            link.href = URL.createObjectURL(result);
            link.click();
          })
          .catch((err) => handleException(err))
          .finally(() => hideLoading());
        break;
      }

      default: {
        if (reporteWhere.FormatoReporte == "Excel") {
          showLoading();
          manager
            .GenerarReportesExcel(reporteWhere)
            .then(async (res) => {
              const link = document.createElement("a");
              const result = await res.blob;
              link.target = "_blank";
              link.download = `${uuid()}.xls`;
              link.href = URL.createObjectURL(result);
              link.click();
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        } else if (reporteWhere.FormatoReporte == "CSV") {
          showLoading();
          manager
            .GenerarReportesCSV(reporteWhere)
            .then(async (res) => {
              const link = document.createElement("a");
              const result = await res.blob;
              link.target = "_blank";
              link.download = `${uuid()}.csv`;
              link.href = URL.createObjectURL(result);
              link.click();
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        } else {
          showLoading();
          manager
            .reporte(reporteWhere)
            .then((res) => {
              setReporte(res.Data);
              setShowCanvasReporte(true);
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
        }
        break;
      }
    }
  };

  return (
    <>
      <ListHeader
        titulo="Filtros de Reporte"
        reporte={imprimirReporte}
      />

      <SectionRow>
        <InputSidebarContainer label="Tipo de Reporte" colSize={"12"}>
          <Select
            className="react-select primary mb-2"
            classNamePrefix="react-select"
            name="TipoReportes"
            onChange={(e) => {
              setReporteWhere({
                ...reporteWhere,
                TipoReporte: e.value,
                FormatoReporte: "Excel"
              });
            }}
            options={TIPO_REPORTE}
            value={TIPO_REPORTE.filter(function (option) {
              return (
                option.value ===
                (reporteWhere.TipoReporte
                  ? reporteWhere.TipoReporte
                  : TIPO_REPORTE[0].value)
              );
            })}
          />

          {reporteWhere.TipoReporte ===
            REPORTE_CANTIDAD_TRANSACCIONES_POR_RANGO_FECHA && (
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="RangoFecha"
                onChange={(e) => {
                  setReporteWhere({
                    ...reporteWhere,
                    RangoFecha: e.value ?? RANGO_FECHA[0],
                  });
                }}
                options={RANGO_FECHA}
                value={RANGO_FECHA.filter(function (option) {
                  return (
                    option.value ===
                    (reporteWhere.RangoFecha
                      ? reporteWhere.RangoFecha
                      : RANGO_FECHA[0].value)
                  );
                })}
              />
            )}

          {reporteWhere.TipoReporte ===
            REPORTE_TRANSACCIONES_POR_RANGO_FECHA && (
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="RangoFecha"
                onChange={(e) => {
                  setReporteWhere({
                    ...reporteWhere,
                    RangoFecha: e.value ?? RANGO_FECHA[0],
                  });
                }}
                options={RANGO_FECHA}
                value={RANGO_FECHA.filter(function (option) {
                  return (
                    option.value ===
                    (reporteWhere.RangoFecha
                      ? reporteWhere.RangoFecha
                      : RANGO_FECHA[0].value)
                  );
                })}
              />
            )}

          {reporteWhere.TipoReporte === REPORTE_TRANSACCIONES_ENVIADAS && (
            <>
              <InputSidebarContainer label="Email Enviado" colSize={"12"}>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="SeEnvio"
                  options={FILTRO_ENVIO}
                  onChange={(e) =>
                    setReporteWhere({ ...reporteWhere, SeEnvio: e.value ?? "-1" })
                  }
                  value={FILTRO_ENVIO.find(
                    (option) => option.value === reporteWhere.SeEnvio
                  )}
                  placeholder="¿Se envió?"
                />
              </InputSidebarContainer>

              <InputSidebarContainer label="Email Leído" colSize={"12"}>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  name="SeRecibio"
                  options={FILTRO_RECEPCION}
                  onChange={(e) =>
                    setReporteWhere({
                      ...reporteWhere,
                      SeRecibio: e.value ?? "-1",
                    })
                  }
                  value={FILTRO_RECEPCION.find(
                    (option) => option.value === reporteWhere.SeRecibio
                  )}
                  placeholder="¿Se recibió?"
                />
              </InputSidebarContainer>
            </>
          )}
        </InputSidebarContainer>

        {reporteWhere.TipoReporte !== Reporte606.TIPO_REPORTE && reporteWhere.TipoReporte !== Reporte607.TIPO_REPORTE && (
          <InputSidebarContainer label="Tipo de Comprobante" colSize={"12"}>
            <Select
              className="react-select primary mb-2"
              classNamePrefix="react-select"
              name="TipoEcfList"
              isMulti
              onChange={(e) => {
                setReporteWhere({
                  ...reporteWhere,
                  TipoEcfList: e ? e.map((option) => option.value) : null,
                });
              }}
              options={reporteWhere.TipoReporte === "V"
                ? [
                  { value: "-1", label: "Todos" },
                  ...tipoComprobantes.filter(option =>
                    ["31", "32", "44", "45", "46"].includes(option.value))
                ]
                : tipoComprobantes}
              value={tipoComprobantes.filter(function (option) {
                return reporteWhere?.TipoEcfList?.some((v) => v === option.value);
              })}
            />
          </InputSidebarContainer>
        )}
      </SectionRow>

      {(reporteWhere.TipoReporte === Reporte606.TIPO_REPORTE ||
        reporteWhere.TipoReporte === Reporte607.TIPO_REPORTE) && (
        <>
          <SectionRow>
            <InputSidebarContainer label="Tipo de Período">
              <RadioGroup
                options={Reporte606.TIPO_PERIODO_LIST}
                selectedOption={reporteWhere.TipoPeriodo606}
                onChange={(e) =>
                  setReporteWhere({
                    ...reporteWhere,
                    TipoPeriodo606: e.target.value,
                  })
                }
              />
            </InputSidebarContainer>
          </SectionRow>

          {reporteWhere.TipoPeriodo606 === Reporte606.TIPO_PERIODO_MENSUAL && (
            <SectionRow multilinea>
              <InputSidebarContainer label="Mes">
                <RadioGroup
                  options={Reporte606.MESES_LIST}
                  selectedOption={reporteWhere.Mes}
                  onChange={(e) =>
                    setReporteWhere({
                      ...reporteWhere,
                      Mes: Number(e.target.value),
                    })
                  }
                />
              </InputSidebarContainer>
            </SectionRow>
          )}

          <SectionRow>
            <InputSidebarContainer label="Año">
              <Select
                className="react-select primary mb-2"
                classNamePrefix="react-select"
                name="Ano"
                options={Reporte606.getAnosList()}
                value={Reporte606.getAnosList().find(
                  (o) => o.value === reporteWhere.Ano
                )}
                onChange={(e) =>
                  setReporteWhere({ ...reporteWhere, Ano: e.value })
                }
              />
            </InputSidebarContainer>
          </SectionRow>
        </>
      )}

      {reporteWhere.TipoReporte !== Reporte606.TIPO_REPORTE &&
        reporteWhere.TipoReporte !== Reporte607.TIPO_REPORTE && (
        <SectionRow>
          <InputSidebarContainer label="Periodo" colSize={"12"}>
            <Select
              className="react-select primary mb-2"
              classNamePrefix="react-select"
              name="Periodo"
              onChange={(e) => {
                setReporteWhere({
                  ...reporteWhere,
                  Periodo: e.value,
                });
              }}
              options={PERIODO_TABLA_LIST}
              value={PERIODO_TABLA_LIST.filter(function (option) {
                return (
                  option.value ===
                  (reporteWhere.Periodo
                    ? reporteWhere.Periodo
                    : PERIODO_TABLA_LIST[0].value)
                );
              })}
            />

            {reporteWhere.Periodo === PERIODO_TABLA_ACTUAL && (
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="Periodicidad"
                onChange={(e) => {
                  setReporteWhere({
                    ...reporteWhere,
                    Periodicidad: e.value,
                  });
                }}
                options={PERIODICIDAD_TABLA_ACTUAL_LIST}
                value={PERIODICIDAD_TABLA_ACTUAL_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (reporteWhere.Periodicidad
                      ? reporteWhere.Periodicidad
                      : PERIODICIDAD_TABLA_ACTUAL_LIST[0].value)
                  );
                })}
              />
            )}

            {reporteWhere.Periodo === PERIODO_TABLA_PASADO && (
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="Periodicidad"
                onChange={(e) => {
                  setReporteWhere({
                    ...reporteWhere,
                    Periodicidad: e.value,
                  });
                }}
                options={PERIODICIDAD_TABLA_PASADO_LIST}
                value={PERIODICIDAD_TABLA_PASADO_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (reporteWhere.Periodicidad
                      ? reporteWhere.Periodicidad
                      : PERIODICIDAD_TABLA_PASADO_LIST[0].value)
                  );
                })}
              />
            )}

            {reporteWhere.Periodo === PERIODO_TABLA_OTRO && (
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="Periodicidad"
                onChange={(e) => {
                  setReporteWhere({
                    ...reporteWhere,
                    Periodicidad: e.value,
                  });
                }}
                options={PERIODICIDAD_TABLA_OTRO_LIST}
                value={PERIODICIDAD_TABLA_OTRO_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (reporteWhere.Periodicidad
                      ? reporteWhere.Periodicidad
                      : PERIODICIDAD_TABLA_OTRO_LIST[0].value)
                  );
                })}
              />
            )}

            {reporteWhere.Periodo === PERIODO_TABLA_OTRO &&
              reporteWhere.Periodicidad === PERIODICIDAD_TABLA_OTRO_RANGO && (
                <InputSidebarContainer label="Rango de Fechas" colSize={"12"}>
                  <DateTimePicker
                    usarLabel={false}
                    esRangoFechas={true}
                    labelFechaInicio="Desde"
                    labelFechaFin="Hasta"
                    fechaInicioOriginal={reporteWhere.FechaInicio}
                    fechaFinOriginal={reporteWhere.FechaFin}
                    onChange={(e) => {
                      if (
                        (reporteWhere.FechaInicio !==
                          DateHelper.formatDate(e.fechaInicio) ||
                          reporteWhere.FechaFin !==
                          DateHelper.formatDate(e.fechaFin)) &&
                        (e.fechaFin || e.fechaInicio)
                      ) {
                        setReporteWhere({
                          ...reporteWhere,
                          FechaInicio: DateHelper.formatDate(e.fechaInicio),
                          FechaFin: DateHelper.formatDate(e.fechaFin),
                        });
                      }
                    }}
                  />
                </InputSidebarContainer>
              )}
          </InputSidebarContainer>

          {reporteWhere.TipoReporte != TIPO_REPORTE_COMPROBANTES_RECIBIDOS &&
            reporteWhere.TipoReporte != TIPO_REPORTE_APROBACIONES_RECIBIDAS && (
              <InputSidebarContainer
                label="Estatus de la Transacción"
                colSize={"12"}
              >
                <Select
                  className="react-select primary mb-2"
                  classNamePrefix="react-select"
                  name="EstadoECF"
                  isMulti
                  onChange={(e) => {
                    setReporteWhere({
                      ...reporteWhere,
                      EstadoECFList: e ? e.map((option) => option.value) : null,
                    });
                  }}
                  options={ESTADO_LIST}
                  value={ESTADO_LIST.filter(function (option) {
                    return reporteWhere?.EstadoECFList?.some(
                      (v) => v === option.value
                    );
                  })}
                />
              </InputSidebarContainer>
            )}
        </SectionRow>
      )}

      <SectionRow>
        {(reporteWhere.TipoReporte === "T" || reporteWhere.TipoReporte === "V" || reporteWhere.TipoReporte === "C" || reporteWhere.TipoReporte === "TF") && (
          <Form
            action=""
            className="form-horizontal p-3"
            id="TypeValidation"
            method=""
            autoComplete="off"
          >
            <SectionRow>
              <div className="d-flex">
                <Form.Check
                  className="divContainer"
                  type="checkbox"
                  aria-label="Montos en Moneda Local"
                  onChange={setCheckedProp}
                  id="ckMontosMonedaLocal"
                  name="ConvertirMonedaLocal"
                  checked={reporteWhere.ConvertirMonedaLocal}
                />
                <label
                  htmlFor="ckMontosMonedaLocal"
                  style={{ marginRight: "15px", marginTop: "3px" }}
                >
                  Montos en Moneda Local
                </label>
              </div>
            </SectionRow>
          </Form>
        )}
      </SectionRow>

      <SectionRow>
        <InputSidebarContainer
          label="Formato del Reporte"
          style={{ display: "flex", justifyContent: "flex-start" }}
        >
          <RadioGroup
            options={FORMATO_REPORTE}
            selectedOption={reporteWhere.FormatoReporte}
            onChange={(e) => {
              setReporteWhere({
                ...reporteWhere,
                FormatoReporte: e.target.value,
              });
            }}
          />
        </InputSidebarContainer>
      </SectionRow>

      <ReporteViewer
        showCanvas={showCanvasReporte}
        setShowCanvas={setShowCanvasReporte}
        reporte={reporte}
      ></ReporteViewer>
    </>
  );
}
